var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 43.4",
    style: {
      enableBackground: "new 0 0 45 43.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,13.6c0-2.9,0-4.4-0.7-5.5C41.4,7.7,41,7.3,40.5,7c-0.9-0.6-2.2-0.7-4.4-0.7c0,0.6,0,1.2,0,1.9V11h2.1 c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6h-2.1v3.1h2.1c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6h-2.1v3.1h2.1c0.9,0,1.6,0.7,1.6,1.6 s-0.7,1.6-1.6,1.6h-2.1v13.6H33V8.4c0-3.9,0-5.9-1.2-7.2S28.5,0,24.6,0h-4.2c-4,0-5.9,0-7.1,1.2S12,4.4,12,8.4v31.9H8.9V26.7H6.8 c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6h2.1v-3.1H6.8c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6h2.1v-3.1H6.8 c-0.9,0-1.6-0.7-1.6-1.6S5.9,11,6.8,11h2.1V8.2c0-0.7,0-1.3,0-1.9C6.6,6.3,5.4,6.4,4.4,7C4,7.3,3.6,7.7,3.3,8.1 c-0.7,1.1-0.7,2.5-0.7,5.5v26.7h-1C0.7,40.3,0,41,0,41.9s0.7,1.6,1.6,1.6h41.9c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6h-1 L42.4,13.6L42.4,13.6z M16.7,20.4c0-0.9,0.7-1.6,1.6-1.6h8.4c0.9,0,1.6,0.7,1.6,1.6S27.5,22,26.7,22h-8.4 C17.4,22,16.7,21.3,16.7,20.4z M16.7,26.7c0-0.9,0.7-1.6,1.6-1.6h8.4c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6h-8.4 C17.4,28.3,16.7,27.6,16.7,26.7z M22.5,34c0.9,0,1.6,0.7,1.6,1.6v4.7h-3.1v-4.7C20.9,34.7,21.6,34,22.5,34z M16.7,8.9 c0-0.9,0.7-1.6,1.6-1.6h8.4c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6h-8.4C17.4,10.5,16.7,9.8,16.7,8.9z M16.7,15.2 c0-0.9,0.7-1.6,1.6-1.6h8.4c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6h-8.4C17.4,16.7,16.7,16,16.7,15.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstate);
export default __webpack_public_path__ + "static/media/estate.f28553ba56b840d84adf1627201d8065.svg";
export { ForwardRef as ReactComponent };